// src/index.ts
export * from "@dialectlabs/react-sdk";

// src/context.tsx
import {
  SolanaSdkFactory
} from "@dialectlabs/blockchain-sdk-solana";
import {
  DialectContextProvider,
  DialectWalletStatesHolder
} from "@dialectlabs/react-sdk";
import { useWallet } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import { useCallback, useEffect, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var SolanaBlockchainSdkWrapper = (props) => {
  const walletFromContext = useWallet();
  const isWalletFromContext = props.customWalletAdapter === void 0;
  const wallet = isWalletFromContext ? walletFromContext : props.customWalletAdapter;
  const {
    walletConnected: { set: setWalletConnected },
    connectionInitiatedState: { set: setConnectionInitiated },
    isSigningFreeTransactionState: { set: setIsSigningFreeTransaction },
    isSigningMessageState: { set: setIsSigningMessage },
    hardwareWalletForcedState: { get: isHardwareWalletForced }
  } = DialectWalletStatesHolder.useContainer();
  const wrapSolanaWallet = useCallback(
    (wallet2) => {
      return {
        publicKey: wallet2.publicKey ?? void 0,
        signTransaction: wallet2.signTransaction ? (
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          async (tx) => {
            const isFreeTx = tx.recentBlockhash && tx.recentBlockhash === PublicKey.default.toString();
            if (isFreeTx) {
              setIsSigningFreeTransaction(true);
            }
            try {
              return await wallet2.signTransaction(tx);
            } catch (e) {
              if (isFreeTx) {
                setConnectionInitiated(false);
              }
              throw e;
            } finally {
              if (isFreeTx) {
                setIsSigningFreeTransaction(false);
              }
            }
          }
        ) : void 0,
        signMessage: !isHardwareWalletForced && wallet2.signMessage ? async (msg) => {
          setIsSigningMessage(true);
          try {
            return await wallet2.signMessage(msg);
          } catch (e) {
            setConnectionInitiated(false);
            throw e;
          } finally {
            setIsSigningMessage(false);
          }
        } : void 0
      };
    },
    [
      isHardwareWalletForced,
      setConnectionInitiated,
      setIsSigningFreeTransaction,
      setIsSigningMessage
    ]
  );
  const blockchainSdkFactory = useMemo(() => {
    if (!wallet || !wallet.publicKey) {
      return null;
    }
    return SolanaSdkFactory.create({
      wallet: wrapSolanaWallet(wallet)
    });
  }, [wallet, wrapSolanaWallet]);
  useEffect(() => {
    setWalletConnected(Boolean(wallet && wallet.publicKey));
  }, [setWalletConnected, wallet]);
  return /* @__PURE__ */ jsx(
    DialectContextProvider,
    {
      ...props,
      blockchainSdkFactory
    }
  );
};
var DialectSolanaSdk = (props) => {
  return /* @__PURE__ */ jsx(DialectWalletStatesHolder.Provider, { children: /* @__PURE__ */ jsx(SolanaBlockchainSdkWrapper, { ...props }) });
};
export {
  DialectSolanaSdk
};
//# sourceMappingURL=index.js.map